import React, { useState, useEffect, useRef } from "react";
import ModifyRecipient from "./ModifyRecipient";
import Utils from "../../../utils";
import { getRecipientList, recipientDetail } from "../../../services/Recipients";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import DeleteRecipient from "./Delete";
import Recipientsimport from "./Recipientsimport";
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import '../../../assets/ManageSleeve.css';

const lengths = Utils.tableShowLengths();

function Recipients() {
  const addButtonRef = useRef(null);
  const delButtonRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [isLoad, setIsLoad] = useState(true);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [isEffect, setIsEffect] = useState(false);
  const [list, setList] = useState([]);
  const [listProcess, setListProcess] = useState('loading...');
  const [totalRecipient, setTotalRecipient] = useState(0);
  const [delId, setDelId] = useState(0);
  const [data, setData] = useState({
    id: 0,
    first_name: '',
    last_name: '',
    email: '',
    country_id: 227,
    mobile: '',
    company_name: '',
    address_1: '',
    address_2: '',
    city: '',
    state: '',
    address_country_id: '',
    zipcode: '',
    readonly: false
  });
  const [openDropdown, setOpenDropdown] = useState(null);

  // Function to render case status badge
  const renderCaseStatusBadge = (caseStatus) => {
    let statusText = 'N/A';
    let statusClass = 'case-status-badge';

    switch (caseStatus?.toLowerCase()) {
      case 'not started':
      case 'notstarted':
        statusText = 'Not Started';
        statusClass += ' case-status-notstarted';
        break;
      case 'in progress':
      case 'inprogress':
        statusText = 'In Progress';
        statusClass += ' case-status-inprogress';
        break;
      case 'submitted':
        statusText = 'Submitted';
        statusClass += ' case-status-submitted';
        break;
      case 'done':
        statusText = 'Done';
        statusClass += ' case-status-done';
        break;
      default:
        statusClass += ' case-status-default';
        break;
    }

    return (
      <span className={statusClass}>
        {statusText}
      </span>
    );
  };

  // Function to render payment status badge
  const renderPaymentStatusBadge = (paymentStatus) => {
    let statusText = 'N/A';
    let statusClass = 'payment-status-badge';

    switch (paymentStatus?.toLowerCase()) {
      case 'unpaid':
        statusText = 'Unpaid';
        statusClass += ' payment-status-unpaid';
        break;
      case 'partial':
        statusText = 'Partial';
        statusClass += ' payment-status-partial';
        break;
      case 'paid':
        statusText = 'Paid';
        statusClass += ' payment-status-paid';
        break;
      default:
        statusClass += ' payment-status-default';
        break;
    }

    return (
      <span className={statusClass}>
        {statusText}
      </span>
    );
  };

  useEffect(() => {
    if (isLoad) {
      setLoading(true);
    }
    setListProcess('loading...');
    setList([]);
    let obj = {
      limit: limit,
      search: search,
      page: page
    };
    getRecipientList(obj)
      .then(response => {
        if (response.data) {
          setTotalRecipient(parseInt(response.data.count));
          setList(response.data.data);

          if (response.data.data.length === 0) {
            setListProcess('No data available.');
          }
        }
        setLoading(false);
        setIsLoad(false);
      })
      .catch(err => {
        setLoading(false);
        setIsLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  }, [limit, search, page, isEffect, isLoad]);

  const handleTableLength = (e) => {
    setPage(1);
    setLimit(parseInt(e.target.value));
  };

  const handleSearch = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };

  const onEditRecipient = (e, data) => {
    e.preventDefault();
    setLoading(true);
    recipientDetail({ id: data.id })
      .then(response => {
        let detail = response.data.data;
        let obj = {
          id: detail.id,
          first_name: detail.first_name,
          last_name: detail.last_name,
          email: detail.email,
          country_id: detail.country_id,
          mobile: detail.mobile,
          company_name: (detail.company_name) ? detail.company_name : '',
          address_1: (detail.address_1) ? detail.address_1 : '',
          address_2: (detail.address_2) ? detail.address_2 : '',
          city: (detail.city) ? detail.city : '',
          state: (detail.state) ? detail.state : '',
          address_country_id: (detail.address_country_id) ? detail.address_country_id : '',
          zipcode: (detail.zip_code) ? detail.zip_code : '',
          readonly: false
        };
        setData(obj);
        addButtonRef.current?.click();
        setLoading(false);
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
        setLoading(true);
      });
  };

  const onViewRecipient = (e, data) => {
    e.preventDefault();
    setLoading(true);
    recipientDetail({ id: data.id })
      .then(response => {
        let detail = response.data.data;
        let obj = {
          id: detail.id,
          first_name: detail.first_name,
          last_name: detail.last_name,
          email: detail.email,
          country_id: detail.country_id,
          mobile: detail.mobile,
          company_name: (detail.company_name) ? detail.company_name : '',
          address_1: (detail.address_1) ? detail.address_1 : '',
          address_2: (detail.address_2) ? detail.address_2 : '',
          city: (detail.city) ? detail.city : '',
          state: (detail.state) ? detail.state : '',
          address_country_id: (detail.address_country_id) ? detail.address_country_id : '',
          zipcode: (detail.zip_code) ? detail.zip_code : '',
          readonly: true
        };
        setData(obj);
        addButtonRef.current?.click();
        setLoading(false);
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
        setLoading(true);
      });
  };

  const onDeleteRecipient = (e, data) => {
    e.preventDefault();
    delButtonRef.current?.click();
    setDelId(data.id);
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}
      <section className="main_wrapper section-bg-color min-height-sleeve">
        <div className="custom_container">
          <div className="recipients-header">
            <div>
              <h2>Recipients</h2>
            </div>
            <div className="recipients-actions">
              <Recipientsimport setIsEffect={setIsEffect} />
              <button
                type="button"
                className="Add_recipient"
                ref={addButtonRef}
                data-bs-toggle="offcanvas"
                data-bs-target="#addRecipients"
                data-bs-backdrop="true"
              >
                <span>+</span> Add Recipient
              </button>
            </div>
          </div>

          <div className="recipients-table-wrapper">
            <div className="recipients-search">
              <div className="search-input-wrapper">
                <i className="bi bi-search search-icon" />
                <input
                  type="text"
                  value={search}
                  onChange={handleSearch}
                  placeholder="Search Recipients"
                  className="search-input"
                />
              </div>
            </div>

            {list.length > 0 ? (
              <div className='recipients-list'>
                <div className='table-responsive'>
                  <table className='table recipients-table border rounded'>
                    <thead className='table-header'>
                      <tr>
                        <th className='table-header-cell'>S.NO.</th>
                        <th className='table-header-cell'>RECIPIENT NAME</th>
                        <th className='table-header-cell'>EMAIL</th>
                        <th className='table-header-cell'>PHONE</th>
                        <th className='table-header-cell'>COMPANY</th>
                        <th className='table-header-cell'>USER</th>
                        <th className='table-header-cell'>PAYMENT STATUS</th>
                        <th className='table-header-cell'>CASE STATUS</th>
                        <th className='table-header-cell'>CREATED DATE</th>
                        <th className='table-header-cell table-header-actions'>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item, index) => {
                        const menu = (
                          <Menu
                            className="custom-rc-dropdown-menu"
                            onClick={({ key }) => {
                              if (key === 'view') onViewRecipient({ preventDefault: () => { } }, item);
                              if (key === 'edit') onEditRecipient({ preventDefault: () => { } }, item);
                              if (key === 'delete') onDeleteRecipient({ preventDefault: () => { } }, item);
                            }}
                          >
                            <MenuItem key="view" className="custom-rc-dropdown-item"><i className="bi bi-eye me-2"></i>View</MenuItem>
                            <MenuItem key="edit" className="custom-rc-dropdown-item"><i className="bi bi-pencil-fill me-2"></i>Edit</MenuItem>
                            <MenuItem key="delete" className="custom-rc-dropdown-item custom-rc-dropdown-delete"><i className="bi bi-trash me-2"></i>Delete</MenuItem>
                          </Menu>
                        );

                        return (
                          <tr key={item.id || index} className='table-row'>
                            <td className='table-cell table-cell-sno'>
                              {(page - 1) * limit + index + 1}
                            </td>
                            <td className='table-cell'>
                              <div className='client-info'>
                                <div>
                                  <div className='client-name'>
                                    {`${item.first_name || ''} ${item.last_name || ''}`.trim() || '-'}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className='table-cell table-cell-text'>
                              {item.email}
                            </td>
                            <td className='table-cell table-cell-text'>
                              {item.mobile ? `+${item.country_code || ''} ${item.mobile}` : '-'}
                            </td>
                            <td className='table-cell table-cell-text'>
                              {item.company_name || '-'}
                            </td>
                            <td className='table-cell table-cell-text'>
                              {item.user_by || '-'}
                            </td>
                            <td className='table-cell'>
                              {renderPaymentStatusBadge(item.payment_status)}
                            </td>
                            <td className='table-cell'>
                              {renderCaseStatusBadge(item.case_status)}
                            </td>
                            <td className='table-cell table-cell-date'>
                              {item.created_at || '-'}
                            </td>
                            <td className='table-cell table-cell-actions'>
                              <div className='action-buttons'>
                                <Dropdown
                                  trigger={["click"]}
                                  overlay={menu}
                                  animation="slide-up"
                                  placement="bottomRight"
                                >
                                  <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', height: '32px' }}>
                                    <i className="bi bi-three-dots-vertical" style={{ fontSize: 20 }}></i>
                                  </span>
                                </Dropdown>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="table_footer_wrap">
                  {totalRecipient > 10 && (
                    <>
                      <div className="d-flex align-items-center mb-4">
                        <span className="me-2 text-dark">Show</span>
                        <select
                          className="form-select"
                          value={limit}
                          style={{ width: '80px' }}
                          onChange={handleTableLength}
                          aria-label="Rows per page"
                        >
                          {lengths && lengths.map((len, i) => (
                            <option value={len} key={i}>{len}</option>
                          ))}
                        </select>
                      </div>

                      <div className="pagination mb-4">
                        <Pagination
                          activePage={page}
                          itemsCountPerPage={limit}
                          totalItemsCount={totalRecipient}
                          pageRangeDisplayed={5}
                          onChange={(e) => setPage(e)}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div className='no-data'>
                <p>{listProcess}</p>
              </div>
            )}
          </div>

          {/* Modals and Offcanvas */}
          <button
            type="button"
            ref={delButtonRef}
            className="d-none"
            data-bs-toggle="modal"
            data-bs-target="#deleteModal"
          />
          <DeleteRecipient delId={delId} setDelId={setDelId} isEffect={isEffect} setIsEffect={setIsEffect} />
          <ModifyRecipient data={data} isEffect={isEffect} setIsEffect={setIsEffect} setData={setData} setLoading={setLoading} />
        </div>
      </section>
    </>
  )
}

export default Recipients;